<template>
  <div
    :style="!checkValid ? 'border: 1px solid #dc3545;' : ''"
    class="gf-multi-file-uploader-item"
  >
    <h6 class="gf-multi-file-uploader-item__icon">
      <i
        v-if="!checkValid"
        class="text-danger gf-icon gf-icon-alert"
      ></i>
      <i
        v-else-if="getSentGroups.includes(file?.name)"
        class="text-success gf-icon gf-icon-check-circle"
      ></i>
      <i
        v-else-if="getIsSent && !getSentGroups.includes(file?.name)"
        class="rotating-icon text-warning gf-icon gf-icon-loading"
      ></i>
      <i
        v-else
        class="gf-icon gf-icon-file"
      />
    </h6>
    <div class="gf-multi-file-uploader-item__loader">
      <div class="gf-multi-file-uploader-item__loader-file">
        <div class="gf-multi-file-uploader-item__loader-file-name">
          <div>{{ file?.name }}</div>
          <div class="text-muted flex-shrink-0">{{ formatedFileSize }}</div>
        </div>

        <button
          v-if="!getIsSent"
          type="button"
          class="btn btn-sm"
          @click="deleteFile"
        >
          <i class="gf-icon gf-icon-x" />
        </button>
      </div>
    </div>
  </div>
</template>
  
  <script>
import GfCustomTooltip from '@/shared-modules/shared-components/shared/GfCustomTooltip.vue';

export default {
  name: 'GfCustomMultiFilePyPiUploaderItems',
  components: {
    GfCustomTooltip
  },
  props: {
    file: {
      type: File
    }
  },
  data() {
    return {
      progress: 0
    };
  },
  computed: {
    getSentGroups() {
      return this.$store.getters.getSentGroups;
    },
    isEmptyArray() {
      return this.getSentGroups > 0 ? true : false;
    },
    getIsSent() {
      return this.$store.getters.getIsSent;
    },
    checkValid() {
      const regex =
        /^(?<name>[a-zA-Z0-9_.-]+)[-_](?<version>\d+\.\d+(\.\d+)?([a-zA-Z0-9_.-]*)?)\.(tar\.gz|whl)$/;
      return regex.test(this.file?.name);
    },
    progressTextColor() {
      return this.progress !== '100' ? { color: 'var(--text)' } : { color: 'var(--text-muted)' };
    },
    formatedFileSize() {
      const bytes = this.file?.size;
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const dm = 0;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
    }
  },
  mounted() {
    // this.upload();
  },
  methods: {
    upload() {
      const reader = new FileReader();
      reader.onprogress = (event) => {
        if (event.lengthComputable) {
          const progress = (event.loaded / event.total) * 100;
          this.updateProgress(progress);
        }
      };
      reader.readAsDataURL(this.file);
    },
    updateProgress(progress) {
      this.progress = progress.toFixed(0);
    },
    deleteFile() {
      this.$emit('delete', this.file);
    }
  }
};
</script>
  
<style lang="scss">
.rotating-icon {
  animation: rot 2s linear infinite;
}

@keyframes rot {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes rot {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

$this: '.gf-multi-file-uploader-item';

#{$this} {
  width: 100%;
  padding: 8px 8px 8px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  background-color: var(--light);
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius);

  #{$this}__icon {
    margin: 0;
    color: var(--text-muted);
  }
  #{$this}__loader {
    width: calc(100% - 24px);

    &-file {
      display: flex;
      justify-content: space-between;

      &-name {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 4px;
        overflow: hidden;
        word-break: break-word;
      }

      & > .btn {
        padding: 0 0.5rem;
        color: var(--text-muted);

        &:hover {
          color: var(--text);
        }
      }
    }

    &-progress {
      margin-right: 6px;
      display: flex;
      align-items: center;
      gap: 6px;

      & > progress {
        width: 100%;
        height: 5px;
        border-radius: 6px;

        &::-webkit-progress-bar {
          background-color: var(--white);
          border-radius: 6px;
        }
        &::-webkit-progress-value {
          background-color: var(--primary);
          border-radius: 6px;
        }
        &::-moz-progress-bar {
          background-color: var(--white);
          border-radius: 6px;
        }
      }
      & > span {
        width: 30px;
        text-align: end;
      }
    }
  }
}
</style>
  